<template>
  <div id="app">
    <!-- Block rendering until store is hydrated -->
    <div v-if="!isStoreReady" style="display: flex; justify-content: center; align-items: center; height: 100vh;">
      <p>Carregando...</p>
    </div>

    <router-view v-else/>
  </div>
</template>


<script>

// import Header from './components/Header'
// import SidebarComponent from './components/SidebarComponent'

export default {
  components: {
    // Header,
    // SidebarComponent
  },

  async created() {
    await this.$store.dispatch('auth/restoreSession')
    await this.$store.dispatch('restoreEmpresa')
    this.$store.commit('setStoreReady', true)
  },

  computed: {
    isStoreReady() {
      return this.$store.state.isStoreReady
    },
    statusMenu() {
      return this.$store.state.auth.isMenuVisible
    }
  }
}
</script>









<style lang="scss">



</style>
